import { Controller } from "@hotwired/stimulus"

// Handles dynamically adding ingredient rows to the recipe form.
// Replaces the inline addIngredientRow() function.
export default class extends Controller {
  static targets = ["container", "template"]
  static values = { index: Number }

  addRow() {
    const html = this.templateTarget.innerHTML.replace(/NEW_INDEX/g, this.indexValue)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.indexValue++
  }
}
